module.exports = __webpack_public_path__ + "img/lx002.16ec7f87.jpg";